"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const modalBorderColor = 'ui4';
const theme = {
  background: 'background.default',
  backgroundMinimised: 'background.tan2',
  backgroundBackdrop: 'overlay2',
  borderColor: modalBorderColor,
  borderRadius: 'small',
  boxShadow: [0, 0, 0, 1, modalBorderColor],
  boxShadowHeader: [0, 1, 0, modalBorderColor],
  maxHeight: 640,
  maxHeightContent: 496,
  fullScreenWidth: '90%',
  width: 480,
  padding: ['xlarge', 'xxlarge'],
  paddingFooter: 'xlarge',
  paddingHeader: 'medium'
};
exports.theme = theme;
//# sourceMappingURL=Modal.theme.js.map